"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsRoutes = void 0;
exports.settingsRoutes = [
    {
        name: 'settings.get',
        path: ['/'],
        method: 'GET'
    },
    {
        name: 'settings.update',
        path: ['/'],
        method: 'POST'
    },
    {
        name: 'settings.google-drive.auth',
        path: ['/google-drive/auth'],
        method: 'POST'
    },
    {
        name: 'settings.google-drive.callback',
        path: ['/google-drive/callback'],
        method: 'GET'
    },
    {
        name: 'settings.google-drive.status',
        path: ['/google-drive/status'],
        method: 'GET'
    },
    {
        name: 'settings.google-drive.disconnect',
        path: ['/google-drive/disconnect'],
        method: 'POST'
    },
    {
        name: 'settings.google-drive.token',
        path: ['/google-drive/token'],
        method: 'GET'
    },
    {
        name: 'settings.google-drive.config',
        path: ['/google-drive/config'],
        method: 'GET'
    },
    {
        name: 'settings.social-media.status',
        path: ['/social-media/status'],
        method: 'GET'
    },
    {
        name: 'settings.social-media.x.auth',
        path: ['/social-media/x/auth'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.x.callback',
        path: ['/social-media/x/callback'],
        method: 'GET'
    },
    {
        name: 'settings.social-media.x.disconnect',
        path: ['/social-media/x/disconnect'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.fb.pages',
        path: ['/social-media/fb/pages'],
        method: 'GET'
    },
    {
        name: 'settings.social-media.fb.auth',
        path: ['/social-media/fb/auth'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.fb.callback',
        path: ['/social-media/fb/callback'],
        method: 'GET'
    },
    {
        name: 'settings.social-media.fb.disconnect',
        path: ['/social-media/fb/disconnect'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.ig.auth',
        path: ['/social-media/ig/auth'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.ig.callback',
        path: ['/social-media/ig/callback'],
        method: 'GET'
    },
    {
        name: 'settings.social-media.ig.disconnect',
        path: ['/social-media/ig/disconnect'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.ig.posts',
        path: ['/social-media/ig/posts'],
        method: 'GET'
    },
    {
        name: 'settings.social-media.ig.publish',
        path: ['/social-media/ig/publish'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.ig.webhook',
        path: ['/social-media/ig/webhook'],
        method: 'GET'
    },
    {
        name: 'settings.social-media.ig.webhook.events',
        path: ['/social-media/ig/webhook'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.yt.auth',
        path: ['/social-media/yt/auth'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.yt.callback',
        path: ['/social-media/yt/callback'],
        method: 'GET'
    },
    {
        name: 'settings.social-media.yt.disconnect',
        path: ['/social-media/yt/disconnect'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.tt.auth',
        path: ['/social-media/tt/auth'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.tt.callback',
        path: ['/social-media/tt/callback'],
        method: 'GET'
    },
    {
        name: 'settings.social-media.tt.disconnect',
        path: ['/social-media/tt/disconnect'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.li.pages',
        path: ['/social-media/li/pages'],
        method: 'GET'
    },
    {
        name: 'settings.social-media.li.auth',
        path: ['/social-media/li/auth'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.li.callback',
        path: ['/social-media/li/callback'],
        method: 'GET'
    },
    {
        name: 'settings.social-media.li.disconnect',
        path: ['/social-media/li/disconnect'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.pt.auth',
        path: ['/social-media/pt/auth'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.pt.callback',
        path: ['/social-media/pt/callback'],
        method: 'GET'
    },
    {
        name: 'settings.social-media.pt.disconnect',
        path: ['/social-media/pt/disconnect'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.pt.boards',
        path: ['/social-media/pt/boards'],
        method: 'GET'
    },
    {
        name: 'settings.social-media.th.auth',
        path: ['/social-media/th/auth'],
        method: 'POST'
    },
    {
        name: 'settings.social-media.th.callback',
        path: ['/social-media/th/callback'],
        method: 'GET'
    },
    {
        name: 'settings.social-media.th.disconnect',
        path: ['/social-media/th/disconnect'],
        method: 'POST'
    },
    // Uninstall (deauth) + delete (data removal) hooks — one pair per platform
    ...['x', 'fb', 'ig', 'yt', 'tt', 'li', 'pt', 'th'].flatMap(p => [
        { name: `settings.social-media.${p}.uninstall`, path: [`/social-media/${p}/uninstall`], method: 'POST' },
        { name: `settings.social-media.${p}.delete`, path: [`/social-media/${p}/delete`], method: 'POST' },
    ])
];
